<template>
    <div class="row no-gutters footer justify-content-center">
        <div class="col-10">
          <div class="row justify-content-center">
            <div class="col-8 col-lg-3 text-center justify-content-center align-self-center">
              <div class="sprite sprite-logo-max sprite-center text-center">
                <div class="sprite-logo"></div>
              </div>
            </div>
            <div class="col-8 col-lg-5">
              <div class="infos d-flex flex-column">
                <div class="p-2">TEL： +886-2-2700-5858</div>
                <div class="p-2">Address：No.16, Ln. 276, Rui’an St., Da’an Dist., Taipei City 10661, Taiwan (R.O.C.)</div>
                <div class="p-2">Copyright &copy; 2019 中國文化大學 Chinese Culture University. All Rights Reserved.</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { globalMixin } from '@/components/_Mixins'

export default {
    mixins: [ globalMixin ],
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue